// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"396": "6966c5a7","486": "79955a4d","488": "e4cfe003","75": "8b155fb8","863": "61547467",}[chunkId] + ".js"
}